<template>
  <LoadingData v-if="loadData" />
  <div
    v-if="
      registros.naturezasOrcamentarias &&
      registros.naturezasOrcamentarias.length > 0
    "
  >
    <div class="row">
      <div
        :class="{
          'col-md-12': filterPeriodoOrcamentoProposta,
          'col-md-9': filterPeriodoOrcamentoReformulacao,
        }"
      >
        <div class="card h-75 border border-primary">
          <div class="card-body p-2">
            <p class="text-center fs-lg mb-0" v-html="textoInformativo" />
          </div>
        </div>
      </div>
      <div v-if="filterPeriodoOrcamentoReformulacao" class="col-md-3">
        <div class="card h-75 border border-primary">
          <div class="card-body d-flex align-items-center">
            <div class="form-check form-switch">
              <input
                type="checkbox"
                class="form-check-input form-check-input-secondary"
                v-model="showNaturezasZeradas"
              />
              <label class="form-check-label" for="sc_r_secondary">
                Exibir Naturezas Zeradas
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="table-responsive table-scrollable">
        <table class="table table-sm table-bordered">
          <thead class="text-center">
            <tr>
              <th
                class="position-sticky start-0 top-0 bg-dark text-white fs-smxs"
              >
                Item de despesa <br />(Natureza Orçamentária)
              </th>
              <th
                v-if="filterPeriodoOrcamentoProposta"
                class="position-sticky top-0 bg-teal text-white fs-smxs"
              >
                Bloqueado
              </th>
              <th class="position-sticky top-0 bg-teal text-white fs-smxs">
                Janeiro
              </th>
              <th class="position-sticky top-0 bg-teal text-white fs-smxs">
                Fevereiro
              </th>
              <th class="position-sticky top-0 bg-teal text-white fs-smxs">
                Março
              </th>
              <th class="position-sticky top-0 bg-teal text-white fs-smxs">
                Abril
              </th>
              <th class="position-sticky top-0 bg-teal text-white fs-smxs">
                Maio
              </th>
              <th class="position-sticky top-0 bg-teal text-white fs-smxs">
                Junho
              </th>
              <th
                v-if="filterPeriodoOrcamentoReformulacao"
                class="position-sticky top-0 bg-teal text-white fs-smxs"
              >
                Saldo Orçamentário Proposto
              </th>
              <th
                v-if="filterPeriodoOrcamentoReformulacao"
                class="position-sticky top-0 bg-teal text-white fs-smxs"
              >
                Bloqueado
              </th>
              <th class="position-sticky top-0 bg-teal text-white fs-smxs">
                Julho
              </th>
              <th class="position-sticky top-0 bg-teal text-white fs-smxs">
                Agosto
              </th>
              <th class="position-sticky top-0 bg-teal text-white fs-smxs">
                Setembro
              </th>
              <th class="position-sticky top-0 bg-teal text-white fs-smxs">
                Outubro
              </th>
              <th class="position-sticky top-0 bg-teal text-white fs-smxs">
                Novembro
              </th>
              <th class="position-sticky top-0 bg-teal text-white fs-smxs">
                Dezembro
              </th>
              <th class="position-sticky top-0 bg-teal text-white fs-smxs">
                Total
              </th>
            </tr>
          </thead>
          <tbody>
            <template
              v-for="(
                naturezaOrcamentaria, index
              ) in registros.naturezasOrcamentarias"
              :key="index"
            >
              <tr
                v-if="
                  filterPeriodoOrcamentoProposta ||
                  showNaturezasZeradas ||
                  (filterPeriodoOrcamentoReformulacao &&
                    (naturezaOrcamentaria.registros.totalAno != 0 ||
                      (naturezaOrcamentaria.registros.totalAno == 0 &&
                        naturezaOrcamentaria.registros.valorBloqueado != 0)))
                "
              >
                <td class="position-sticky start-0 fs-smxs">
                  {{ naturezaOrcamentaria.codTBOrcamento }} -
                  {{ naturezaOrcamentaria.nome }}
                </td>
                <td
                  v-if="filterPeriodoOrcamentoProposta"
                  class="fs-smxs text-center"
                >
                  {{
                    moneyToCurrencyBr(
                      naturezaOrcamentaria.registros.valorBloqueado,
                    )
                  }}
                </td>
                <td class="fs-smxs text-center">
                  <div class="input-group input-group-sm">
                    <span class="input-group-text">R$</span>
                    <input
                      v-if="orcamentoPropostaIsOpen"
                      type="text"
                      class="form-control text-center"
                      v-maska="'#*'"
                      @input="
                        createUpdateRegistro({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 1,
                          valor: naturezaOrcamentaria.registros.janeiro,
                        })
                      "
                      @paste.prevent="
                        handlerPaste($event, {
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 1,
                        })
                      "
                      v-model="naturezaOrcamentaria.registros.janeiro"
                    />
                    <input
                      v-if="orcamentoPropostaIsClosed"
                      class="form-control text-center"
                      :value="
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.registros.janeiro,
                        )
                      "
                      disabled
                    />
                    <span
                      v-if="orcamentoPropostaIsOpen"
                      class="input-group-text"
                    >
                      ,00
                    </span>
                    <span
                      class="input-group-text cursor-pointer p-0"
                      title="Exibir Memória de Cálculo"
                      @click="
                        getMemoriaCalculo({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 1,
                          hide: naturezaOrcamentaria.memoriasCalculos
                            .showJaneiro,
                        })
                      "
                    >
                      <i class="ph-calculator text-success" />
                    </span>
                  </div>
                  <div
                    v-if="naturezaOrcamentaria.memoriasCalculos.showJaneiro"
                    class="mt-2"
                    ref="textarea"
                  >
                    <textarea
                      class="form-control textarea-custom"
                      @input="
                        createUpdateMemoriaCalculo({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 1,
                          texto: naturezaOrcamentaria.memoriasCalculos.janeiro,
                        })
                      "
                      @keypress="resizeTextArea"
                      v-model="naturezaOrcamentaria.memoriasCalculos.janeiro"
                      :disabled="orcamentoPropostaIsClosed"
                    />
                  </div>
                </td>
                <td class="fs-smxs text-center">
                  <div class="input-group input-group-sm">
                    <span class="input-group-text">R$</span>
                    <input
                      v-if="orcamentoPropostaIsOpen"
                      type="text"
                      class="form-control text-center"
                      v-maska="'#*'"
                      @input="
                        createUpdateRegistro({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 2,
                          valor: naturezaOrcamentaria.registros.fevereiro,
                        })
                      "
                      @paste.prevent="
                        handlerPaste($event, {
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 2,
                        })
                      "
                      v-model="naturezaOrcamentaria.registros.fevereiro"
                    />
                    <input
                      v-if="orcamentoPropostaIsClosed"
                      class="form-control text-center"
                      :value="
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.registros.fevereiro,
                        )
                      "
                      disabled
                    />
                    <span
                      v-if="orcamentoPropostaIsOpen"
                      class="input-group-text"
                    >
                      ,00
                    </span>
                    <span
                      class="input-group-text cursor-pointer p-0"
                      title="Exibir Memória de Cálculo"
                      @click="
                        getMemoriaCalculo({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 2,
                          hide: naturezaOrcamentaria.memoriasCalculos
                            .showFevereiro,
                        })
                      "
                    >
                      <i class="ph-calculator text-success" />
                    </span>
                  </div>
                  <div
                    v-if="naturezaOrcamentaria.memoriasCalculos.showFevereiro"
                    class="mt-2"
                    ref="textarea"
                  >
                    <textarea
                      class="form-control textarea-custom"
                      @input="
                        createUpdateMemoriaCalculo({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 2,
                          texto:
                            naturezaOrcamentaria.memoriasCalculos.fevereiro,
                        })
                      "
                      @keypress="resizeTextArea"
                      v-model="naturezaOrcamentaria.memoriasCalculos.fevereiro"
                      :disabled="orcamentoPropostaIsClosed"
                    />
                  </div>
                </td>
                <td class="fs-smxs text-center">
                  <div class="input-group input-group-sm">
                    <span class="input-group-text">R$</span>
                    <input
                      v-if="orcamentoPropostaIsOpen"
                      type="text"
                      class="form-control text-center"
                      v-maska="'#*'"
                      @input="
                        createUpdateRegistro({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 3,
                          valor: naturezaOrcamentaria.registros.marco,
                        })
                      "
                      @paste.prevent="
                        handlerPaste($event, {
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 3,
                        })
                      "
                      v-model="naturezaOrcamentaria.registros.marco"
                    />
                    <input
                      v-if="orcamentoPropostaIsClosed"
                      class="form-control text-center"
                      :value="
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.registros.marco,
                        )
                      "
                      disabled
                    />
                    <span
                      v-if="orcamentoPropostaIsOpen"
                      class="input-group-text"
                    >
                      ,00
                    </span>
                    <span
                      class="input-group-text cursor-pointer p-0"
                      title="Exibir Memória de Cálculo"
                      @click="
                        getMemoriaCalculo({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 3,
                          hide: naturezaOrcamentaria.memoriasCalculos.showMarco,
                        })
                      "
                    >
                      <i class="ph-calculator text-success" />
                    </span>
                  </div>
                  <div
                    v-if="naturezaOrcamentaria.memoriasCalculos.showMarco"
                    class="mt-2"
                    ref="textarea"
                  >
                    <textarea
                      class="form-control textarea-custom"
                      @input="
                        createUpdateMemoriaCalculo({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 3,
                          texto: naturezaOrcamentaria.memoriasCalculos.marco,
                        })
                      "
                      @keypress="resizeTextArea"
                      v-model="naturezaOrcamentaria.memoriasCalculos.marco"
                      :disabled="orcamentoPropostaIsClosed"
                    />
                  </div>
                </td>
                <td class="fs-smxs text-center">
                  <div class="input-group input-group-sm">
                    <span class="input-group-text">R$</span>
                    <input
                      v-if="orcamentoPropostaIsOpen"
                      type="text"
                      class="form-control text-center"
                      v-maska="'#*'"
                      @input="
                        createUpdateRegistro({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 4,
                          valor: naturezaOrcamentaria.registros.abril,
                        })
                      "
                      @paste.prevent="
                        handlerPaste($event, {
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 4,
                        })
                      "
                      v-model="naturezaOrcamentaria.registros.abril"
                    />
                    <input
                      v-if="orcamentoPropostaIsClosed"
                      class="form-control text-center"
                      :value="
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.registros.abril,
                        )
                      "
                      disabled
                    />
                    <span
                      v-if="orcamentoPropostaIsOpen"
                      class="input-group-text"
                    >
                      ,00
                    </span>
                    <span
                      class="input-group-text cursor-pointer p-0"
                      title="Exibir Memória de Cálculo"
                      @click="
                        getMemoriaCalculo({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 4,
                          hide: naturezaOrcamentaria.memoriasCalculos.showAbril,
                        })
                      "
                    >
                      <i class="ph-calculator text-success" />
                    </span>
                  </div>
                  <div
                    v-if="naturezaOrcamentaria.memoriasCalculos.showAbril"
                    class="mt-2"
                    ref="textarea"
                  >
                    <textarea
                      class="form-control textarea-custom"
                      @input="
                        createUpdateMemoriaCalculo({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 4,
                          texto: naturezaOrcamentaria.memoriasCalculos.abril,
                        })
                      "
                      @keypress="resizeTextArea"
                      v-model="naturezaOrcamentaria.memoriasCalculos.abril"
                      :disabled="orcamentoPropostaIsClosed"
                    />
                  </div>
                </td>
                <td class="fs-smxs text-center">
                  <div class="input-group input-group-sm">
                    <span class="input-group-text">R$</span>
                    <input
                      v-if="orcamentoPropostaIsOpen"
                      type="text"
                      class="form-control text-center"
                      v-maska="'#*'"
                      @input="
                        createUpdateRegistro({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 5,
                          valor: naturezaOrcamentaria.registros.maio,
                        })
                      "
                      @paste.prevent="
                        handlerPaste($event, {
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 5,
                        })
                      "
                      v-model="naturezaOrcamentaria.registros.maio"
                    />
                    <input
                      v-if="orcamentoPropostaIsClosed"
                      class="form-control text-center"
                      :value="
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.registros.maio,
                        )
                      "
                      disabled
                    />
                    <span
                      v-if="orcamentoPropostaIsOpen"
                      class="input-group-text"
                    >
                      ,00
                    </span>
                    <span
                      class="input-group-text cursor-pointer p-0"
                      title="Exibir Memória de Cálculo"
                      @click="
                        getMemoriaCalculo({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 5,
                          hide: naturezaOrcamentaria.memoriasCalculos.showMaio,
                        })
                      "
                    >
                      <i class="ph-calculator text-success" />
                    </span>
                  </div>
                  <div
                    v-if="naturezaOrcamentaria.memoriasCalculos.showMaio"
                    class="mt-2"
                    ref="textarea"
                  >
                    <textarea
                      class="form-control textarea-custom"
                      @input="
                        createUpdateMemoriaCalculo({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 5,
                          texto: naturezaOrcamentaria.memoriasCalculos.maio,
                        })
                      "
                      @keypress="resizeTextArea"
                      v-model="naturezaOrcamentaria.memoriasCalculos.maio"
                      :disabled="orcamentoPropostaIsClosed"
                    />
                  </div>
                </td>
                <td class="fs-smxs text-center">
                  <div class="input-group input-group-sm">
                    <span class="input-group-text">R$</span>
                    <input
                      v-if="orcamentoPropostaIsOpen"
                      type="text"
                      class="form-control text-center"
                      v-maska="'#*'"
                      @input="
                        createUpdateRegistro({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 6,
                          valor: naturezaOrcamentaria.registros.junho,
                        })
                      "
                      @paste.prevent="
                        handlerPaste($event, {
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 6,
                        })
                      "
                      v-model="naturezaOrcamentaria.registros.junho"
                    />
                    <input
                      v-if="orcamentoPropostaIsClosed"
                      class="form-control text-center"
                      :value="
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.registros.junho,
                        )
                      "
                      disabled
                    />
                    <span
                      v-if="orcamentoPropostaIsOpen"
                      class="input-group-text"
                    >
                      ,00
                    </span>
                    <span
                      class="input-group-text cursor-pointer p-0"
                      title="Exibir Memória de Cálculo"
                      @click="
                        getMemoriaCalculo({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 6,
                          hide: naturezaOrcamentaria.memoriasCalculos.showJunho,
                        })
                      "
                    >
                      <i class="ph-calculator text-success" />
                    </span>
                  </div>
                  <div
                    v-if="naturezaOrcamentaria.memoriasCalculos.showJunho"
                    class="mt-2"
                    ref="textarea"
                  >
                    <textarea
                      class="form-control textarea-custom"
                      @input="
                        createUpdateMemoriaCalculo({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 6,
                          texto: naturezaOrcamentaria.memoriasCalculos.junho,
                        })
                      "
                      @keypress="resizeTextArea"
                      v-model="naturezaOrcamentaria.memoriasCalculos.junho"
                      :disabled="orcamentoPropostaIsClosed"
                    />
                  </div>
                </td>
                <td
                  v-if="filterPeriodoOrcamentoReformulacao"
                  class="fs-smxs text-center"
                >
                  {{
                    moneyToCurrencyBr(
                      naturezaOrcamentaria.registros.saldoProposto,
                    )
                  }}
                </td>
                <td
                  v-if="filterPeriodoOrcamentoReformulacao"
                  class="fs-smxs text-center"
                >
                  {{
                    moneyToCurrencyBr(
                      naturezaOrcamentaria.registros.valorBloqueado,
                    )
                  }}
                </td>
                <td class="fs-smxs text-center">
                  <div class="input-group input-group-sm">
                    <span class="input-group-text">R$</span>
                    <input
                      v-if="orcamentoPropostaOrReformulacaoIsOpen"
                      type="text"
                      class="form-control text-center"
                      v-maska="'#*'"
                      @input="
                        createUpdateRegistro({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 7,
                          valor: naturezaOrcamentaria.registros.julho,
                        })
                      "
                      @paste.prevent="
                        handlerPaste($event, {
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 7,
                        })
                      "
                      v-model="naturezaOrcamentaria.registros.julho"
                    />
                    <input
                      v-if="orcamentoPropostaOrReformulacaoIsClosed"
                      class="form-control text-center"
                      :value="
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.registros.julho,
                        )
                      "
                      disabled
                    />
                    <span
                      v-if="orcamentoPropostaOrReformulacaoIsOpen"
                      class="input-group-text"
                    >
                      ,00
                    </span>
                    <span
                      class="input-group-text cursor-pointer p-0"
                      title="Exibir Memória de Cálculo"
                      @click="
                        getMemoriaCalculo({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 7,
                          hide: naturezaOrcamentaria.memoriasCalculos.showJulho,
                        })
                      "
                    >
                      <i class="ph-calculator text-success" />
                    </span>
                  </div>
                  <div
                    v-if="naturezaOrcamentaria.memoriasCalculos.showJulho"
                    class="mt-2"
                    ref="textarea"
                  >
                    <textarea
                      class="form-control textarea-custom"
                      @input="
                        createUpdateMemoriaCalculo({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 7,
                          texto: naturezaOrcamentaria.memoriasCalculos.julho,
                        })
                      "
                      @keypress="resizeTextArea"
                      v-model="naturezaOrcamentaria.memoriasCalculos.julho"
                      :disabled="orcamentoPropostaOrReformulacaoIsClosed"
                    />
                  </div>
                </td>
                <td class="fs-smxs text-center">
                  <div class="input-group input-group-sm">
                    <span class="input-group-text">R$</span>
                    <input
                      v-if="orcamentoPropostaOrReformulacaoIsOpen"
                      type="text"
                      class="form-control text-center"
                      v-maska="'#*'"
                      @input="
                        createUpdateRegistro({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 8,
                          valor: naturezaOrcamentaria.registros.agosto,
                        })
                      "
                      @paste.prevent="
                        handlerPaste($event, {
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 8,
                        })
                      "
                      v-model="naturezaOrcamentaria.registros.agosto"
                    />
                    <input
                      v-if="orcamentoPropostaOrReformulacaoIsClosed"
                      class="form-control text-center"
                      :value="
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.registros.agosto,
                        )
                      "
                      disabled
                    />
                    <span
                      v-if="orcamentoPropostaOrReformulacaoIsOpen"
                      class="input-group-text"
                    >
                      ,00
                    </span>
                    <span
                      class="input-group-text cursor-pointer p-0"
                      title="Exibir Memória de Cálculo"
                      @click="
                        getMemoriaCalculo({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 8,
                          hide: naturezaOrcamentaria.memoriasCalculos
                            .showAgosto,
                        })
                      "
                    >
                      <i class="ph-calculator text-success" />
                    </span>
                  </div>
                  <div
                    v-if="naturezaOrcamentaria.memoriasCalculos.showAgosto"
                    class="mt-2"
                    ref="textarea"
                  >
                    <textarea
                      class="form-control textarea-custom"
                      @input="
                        createUpdateMemoriaCalculo({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 8,
                          texto: naturezaOrcamentaria.memoriasCalculos.agosto,
                        })
                      "
                      @keypress="resizeTextArea"
                      v-model="naturezaOrcamentaria.memoriasCalculos.agosto"
                      :disabled="orcamentoPropostaOrReformulacaoIsClosed"
                    />
                  </div>
                </td>
                <td class="fs-smxs text-center">
                  <div class="input-group input-group-sm">
                    <span class="input-group-text">R$</span>
                    <input
                      v-if="orcamentoPropostaOrReformulacaoIsOpen"
                      type="text"
                      class="form-control text-center"
                      v-maska="'#*'"
                      @input="
                        createUpdateRegistro({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 9,
                          valor: naturezaOrcamentaria.registros.setembro,
                        })
                      "
                      @paste.prevent="
                        handlerPaste($event, {
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 9,
                        })
                      "
                      v-model="naturezaOrcamentaria.registros.setembro"
                    />
                    <input
                      v-if="orcamentoPropostaOrReformulacaoIsClosed"
                      class="form-control text-center"
                      :value="
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.registros.setembro,
                        )
                      "
                      disabled
                    />
                    <span
                      v-if="orcamentoPropostaOrReformulacaoIsOpen"
                      class="input-group-text"
                    >
                      ,00
                    </span>
                    <span
                      class="input-group-text cursor-pointer p-0"
                      title="Exibir Memória de Cálculo"
                      @click="
                        getMemoriaCalculo({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 9,
                          hide: naturezaOrcamentaria.memoriasCalculos
                            .showSetembro,
                        })
                      "
                    >
                      <i class="ph-calculator text-success" />
                    </span>
                  </div>
                  <div
                    v-if="naturezaOrcamentaria.memoriasCalculos.showSetembro"
                    class="mt-2"
                    ref="textarea"
                  >
                    <textarea
                      class="form-control textarea-custom"
                      @input="
                        createUpdateMemoriaCalculo({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 9,
                          texto: naturezaOrcamentaria.memoriasCalculos.setembro,
                        })
                      "
                      @keypress="resizeTextArea"
                      v-model="naturezaOrcamentaria.memoriasCalculos.setembro"
                      :disabled="orcamentoPropostaOrReformulacaoIsClosed"
                    />
                  </div>
                </td>
                <td class="fs-smxs text-center">
                  <div class="input-group input-group-sm">
                    <span class="input-group-text">R$</span>
                    <input
                      v-if="orcamentoPropostaOrReformulacaoIsOpen"
                      type="text"
                      class="form-control text-center"
                      v-maska="'#*'"
                      @input="
                        createUpdateRegistro({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 10,
                          valor: naturezaOrcamentaria.registros.outubro,
                        })
                      "
                      @paste.prevent="
                        handlerPaste($event, {
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 10,
                        })
                      "
                      v-model="naturezaOrcamentaria.registros.outubro"
                    />
                    <input
                      v-if="orcamentoPropostaOrReformulacaoIsClosed"
                      class="form-control text-center"
                      :value="
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.registros.outubro,
                        )
                      "
                      disabled
                    />
                    <span
                      v-if="orcamentoPropostaOrReformulacaoIsOpen"
                      class="input-group-text"
                    >
                      ,00
                    </span>
                    <span
                      class="input-group-text cursor-pointer p-0"
                      title="Exibir Memória de Cálculo"
                      @click="
                        getMemoriaCalculo({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 10,
                          hide: naturezaOrcamentaria.memoriasCalculos
                            .showOutubro,
                        })
                      "
                    >
                      <i class="ph-calculator text-success" />
                    </span>
                    <div
                      v-if="naturezaOrcamentaria.memoriasCalculos.showOutubro"
                      class="mt-2"
                      ref="textarea"
                    >
                      <textarea
                        class="form-control textarea-custom"
                        @input="
                          createUpdateMemoriaCalculo({
                            codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                            mes: 10,
                            texto:
                              naturezaOrcamentaria.memoriasCalculos.outubro,
                          })
                        "
                        @keypress="resizeTextArea"
                        v-model="naturezaOrcamentaria.memoriasCalculos.outubro"
                        :disabled="orcamentoPropostaOrReformulacaoIsClosed"
                      />
                    </div>
                  </div>
                </td>
                <td class="fs-smxs text-center">
                  <div class="input-group input-group-sm">
                    <span class="input-group-text">R$</span>
                    <input
                      v-if="orcamentoPropostaOrReformulacaoIsOpen"
                      type="text"
                      class="form-control text-center"
                      v-maska="'#*'"
                      @input="
                        createUpdateRegistro({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 11,
                          valor: naturezaOrcamentaria.registros.novembro,
                        })
                      "
                      @paste.prevent="
                        handlerPaste($event, {
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 11,
                        })
                      "
                      v-model="naturezaOrcamentaria.registros.novembro"
                    />
                    <input
                      v-if="orcamentoPropostaOrReformulacaoIsClosed"
                      class="form-control text-center"
                      :value="
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.registros.novembro,
                        )
                      "
                      disabled
                    />
                    <span
                      v-if="orcamentoPropostaOrReformulacaoIsOpen"
                      class="input-group-text"
                    >
                      ,00
                    </span>
                    <span
                      class="input-group-text cursor-pointer p-0"
                      title="Exibir Memória de Cálculo"
                      @click="
                        getMemoriaCalculo({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 11,
                          hide: naturezaOrcamentaria.memoriasCalculos
                            .showNovembro,
                        })
                      "
                    >
                      <i class="ph-calculator text-success" />
                    </span>
                  </div>
                  <div
                    v-if="naturezaOrcamentaria.memoriasCalculos.showNovembro"
                    class="mt-2"
                    ref="textarea"
                  >
                    <textarea
                      class="form-control textarea-custom"
                      @input="
                        createUpdateMemoriaCalculo({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 11,
                          texto: naturezaOrcamentaria.memoriasCalculos.novembro,
                        })
                      "
                      @keypress="resizeTextArea"
                      v-model="naturezaOrcamentaria.memoriasCalculos.novembro"
                      :disabled="orcamentoPropostaOrReformulacaoIsClosed"
                    />
                  </div>
                </td>
                <td class="fs-smxs text-center">
                  <div class="input-group input-group-sm">
                    <span class="input-group-text">R$</span>
                    <input
                      v-if="orcamentoPropostaOrReformulacaoIsOpen"
                      type="text"
                      class="form-control text-center"
                      v-maska="'#*'"
                      @input="
                        createUpdateRegistro({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 12,
                          valor: naturezaOrcamentaria.registros.dezembro,
                        })
                      "
                      @paste.prevent="
                        handlerPaste($event, {
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 12,
                        })
                      "
                      v-model="naturezaOrcamentaria.registros.dezembro"
                    />
                    <input
                      v-if="orcamentoPropostaOrReformulacaoIsClosed"
                      class="form-control text-center"
                      :value="
                        moneyToCurrencyBrNoSymbol(
                          naturezaOrcamentaria.registros.dezembro,
                        )
                      "
                      disabled
                    />
                    <span
                      v-if="orcamentoPropostaOrReformulacaoIsOpen"
                      class="input-group-text"
                    >
                      ,00
                    </span>
                    <span
                      class="input-group-text cursor-pointer p-0"
                      title="Exibir Memória de Cálculo"
                      @click="
                        getMemoriaCalculo({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 12,
                          hide: naturezaOrcamentaria.memoriasCalculos
                            .showDezembro,
                        })
                      "
                    >
                      <i class="ph-calculator text-success" />
                    </span>
                  </div>
                  <div
                    v-if="naturezaOrcamentaria.memoriasCalculos.showDezembro"
                    class="mt-2"
                    ref="textarea"
                  >
                    <textarea
                      class="form-control textarea-custom"
                      @input="
                        createUpdateMemoriaCalculo({
                          codTBOrcamento: naturezaOrcamentaria.codTBOrcamento,
                          mes: 12,
                          texto: naturezaOrcamentaria.memoriasCalculos.dezembro,
                        })
                      "
                      @keypress="resizeTextArea"
                      v-model="naturezaOrcamentaria.memoriasCalculos.dezembro"
                      :disabled="orcamentoPropostaOrReformulacaoIsClosed"
                    />
                  </div>
                </td>
                <td
                  class="fs-smxs text-center"
                  :class="{
                    'text-danger':
                      Number(naturezaOrcamentaria.registros.totalAno) <
                      Number(naturezaOrcamentaria.registros.bloqueado),
                    'text-success':
                      Number(naturezaOrcamentaria.registros.totalAno) >=
                      Number(naturezaOrcamentaria.registros.bloqueado),
                  }"
                  :title="
                    Number(naturezaOrcamentaria.registros.totalAno) <
                    Number(naturezaOrcamentaria.registros.bloqueado)
                      ? `O valor bloqueado ${moneyToCurrencyBr(
                          naturezaOrcamentaria.registros.bloqueado,
                        )} é superior ao acumulado ${moneyToCurrencyBr(
                          naturezaOrcamentaria.registros.totalAno,
                        )}, faltam ${moneyToCurrencyBr(
                          Math.abs(
                            Number(naturezaOrcamentaria.registros.totalAno) -
                              Number(naturezaOrcamentaria.registros.bloqueado),
                          ),
                        )}`
                      : ''
                  "
                >
                  {{
                    moneyToCurrencyBr(naturezaOrcamentaria.registros.totalAno)
                  }}
                </td>
              </tr>
            </template>
            <tr>
              <td class="position-sticky start-0"><strong>TOTAIS</strong></td>
              <td
                v-if="filterPeriodoOrcamentoProposta"
                class="fs-smxs text-center"
              >
                {{ moneyToCurrencyBr(registros.totais.valorBloqueado) }}
              </td>
              <td class="fs-smxs text-center">
                {{ moneyToCurrencyBr(registros.totais.janeiro) }}
              </td>
              <td class="fs-smxs text-center">
                {{ moneyToCurrencyBr(registros.totais.fevereiro) }}
              </td>
              <td class="fs-smxs text-center">
                {{ moneyToCurrencyBr(registros.totais.marco) }}
              </td>
              <td class="fs-smxs text-center">
                {{ moneyToCurrencyBr(registros.totais.abril) }}
              </td>
              <td class="fs-smxs text-center">
                {{ moneyToCurrencyBr(registros.totais.maio) }}
              </td>
              <td class="fs-smxs text-center">
                {{ moneyToCurrencyBr(registros.totais.junho) }}
              </td>
              <td
                v-if="filterPeriodoOrcamentoReformulacao"
                class="fs-smxs text-center"
              >
                {{ moneyToCurrencyBr(registros.totais.saldoProposto) }}
              </td>
              <td
                v-if="filterPeriodoOrcamentoReformulacao"
                class="fs-smxs text-center"
              >
                {{ moneyToCurrencyBr(registros.totais.valorBloqueado) }}
              </td>
              <td class="fs-smxs text-center">
                {{ moneyToCurrencyBr(registros.totais.julho) }}
              </td>
              <td class="fs-smxs text-center">
                {{ moneyToCurrencyBr(registros.totais.agosto) }}
              </td>
              <td class="fs-smxs text-center">
                {{ moneyToCurrencyBr(registros.totais.setembro) }}
              </td>
              <td class="fs-smxs text-center">
                {{ moneyToCurrencyBr(registros.totais.outubro) }}
              </td>
              <td class="fs-smxs text-center">
                {{ moneyToCurrencyBr(registros.totais.novembro) }}
              </td>
              <td class="fs-smxs text-center">
                {{ moneyToCurrencyBr(registros.totais.dezembro) }}
              </td>
              <td class="fs-smxs text-center">
                {{ moneyToCurrencyBr(registros.totais.totalAno) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <AssociarNaturezaOrcamentaria
      v-if="orcamentoPropostaOrReformulacaoIsOpen"
      :filters="filters"
      @realodData="seach"
    />
  </div>
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import AssociarNaturezaOrcamentaria from '@/components/preenchimento/AssociarNaturezaOrcamentaria.vue'
import { mapGetters } from 'vuex'
import { maska } from 'maska'
import { debounce } from 'lodash'
import { moneyToCurrencyBr, moneyToCurrencyBrNoSymbol } from '@/utils/strings'
import PeriodoOrcamentoEnum from '@/enum/periodoOrcamentoEnum'

export default {
  name: 'PreenchimentoResult',

  components: {
    LoadingData,
    AssociarNaturezaOrcamentaria,
  },

  props: {
    seachData: {
      type: Boolean,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
    textoInformativo: {
      type: String,
      required: true,
    },
  },

  directives: { maska },

  emits: ['seachData'],

  data() {
    return {
      registros: {},
      loadData: false,
      showNaturezasZeradas: true,
      meses: {
        1: 'janeiro',
        2: 'fevereiro',
        3: 'marco',
        4: 'abril',
        5: 'maio',
        6: 'junho',
        7: 'julho',
        8: 'agosto',
        9: 'setembro',
        10: 'outubro',
        11: 'novembro',
        12: 'dezembro',
      },
      moneyToCurrencyBr,
      moneyToCurrencyBrNoSymbol,
    }
  },

  computed: {
    ...mapGetters(['user', 'orcamentoSelecionado']),

    periodoOrcamentoProposta() {
      return (
        this.orcamentoSelecionado.periodoOrcamento ===
        PeriodoOrcamentoEnum.PROPOSTA
      )
    },

    periodoOrcamentoReformulacao() {
      return (
        this.orcamentoSelecionado.periodoOrcamento ===
        PeriodoOrcamentoEnum.REFORMULACAO
      )
    },

    filterPeriodoOrcamentoProposta() {
      return (
        Number(this.filters.periodoOrcamento) === PeriodoOrcamentoEnum.PROPOSTA
      )
    },

    filterPeriodoOrcamentoReformulacao() {
      return (
        Number(this.filters.periodoOrcamento) ===
        PeriodoOrcamentoEnum.REFORMULACAO
      )
    },

    orcamentoPropostaIsOpen() {
      return (
        this.periodoOrcamentoProposta && this.filterPeriodoOrcamentoProposta
      )
    },

    orcamentoPropostaIsClosed() {
      return (
        !this.periodoOrcamentoProposta ||
        this.filterPeriodoOrcamentoReformulacao
      )
    },

    orcamentoPropostaOrReformulacaoIsOpen() {
      return (
        (this.periodoOrcamentoProposta &&
          this.filterPeriodoOrcamentoProposta) ||
        (this.periodoOrcamentoReformulacao &&
          this.filterPeriodoOrcamentoReformulacao)
      )
    },

    orcamentoPropostaOrReformulacaoIsClosed() {
      return (
        (this.periodoOrcamentoProposta &&
          this.filterPeriodoOrcamentoReformulacao) ||
        (this.periodoOrcamentoReformulacao &&
          this.filterPeriodoOrcamentoProposta) ||
        (!this.periodoOrcamentoProposta && !this.periodoOrcamentoReformulacao)
      )
    },
  },

  watch: {
    seachData: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.seach()
        }
      },
      immediate: true,
    },
    filters: {
      handler(newVal, oldVal) {
        if (
          newVal.codCCustoPai &&
          newVal.codCCustoFilho &&
          newVal.orcamentoId &&
          newVal.periodoOrcamento &&
          !this.seachData
        ) {
          this.registros = {}
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    async seach() {
      try {
        this.loadData = true
        this.registros = {}

        this.registros = await this.$store.dispatch(
          'getRegistros',
          this.filters,
        )

        this.$emit('seachData', false)
        this.loadData = false
      } catch (error) {
        this.$emit('seachData', false)
        this.loadData = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async createUpdateRegistro(registro) {
      try {
        await this.$store.dispatch('saveUpdateRegistro', {
          codCCustoPai: this.filters.codCCustoPai,
          codCCustoFilho: this.filters.codCCustoFilho,
          orcamentoId: this.filters.orcamentoId,
          registro: {
            codTBOrcamento: registro.codTBOrcamento,
            mes: registro.mes,
            valorProposta: registro.valor,
            valorReformulacao: registro.valor,
          },
        })

        this.recalculateTotals(registro)
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async getMemoriaCalculo(filters) {
      try {
        let memoriaCalculo = null

        if (!filters.hide) {
          memoriaCalculo = await this.$store.dispatch('getMemoriaCalculo', {
            codCCustoPai: this.filters.codCCustoPai,
            codCCustoFilho: this.filters.codCCustoFilho,
            orcamentoId: this.filters.orcamentoId,
            codTBOrcamento: filters.codTBOrcamento,
            mes: filters.mes,
          })
        }

        this.registros.naturezasOrcamentarias =
          this.registros.naturezasOrcamentarias.map((naturezaOrcamentaria) => {
            if (
              naturezaOrcamentaria.codTBOrcamento === filters.codTBOrcamento
            ) {
              const mesSelected = this.meses[filters.mes]
              const showMes = `show${
                mesSelected.charAt(0).toUpperCase() + mesSelected.slice(1)
              }`

              return {
                ...naturezaOrcamentaria,
                memoriasCalculos: {
                  ...naturezaOrcamentaria.memoriasCalculos,
                  [showMes]: !naturezaOrcamentaria.memoriasCalculos[showMes],
                  [mesSelected]: memoriaCalculo ? memoriaCalculo.texto : '',
                },
              }
            }
            return { ...naturezaOrcamentaria }
          })

        if (!filters.hide) {
          this.$nextTick(() => {
            this.$refs.textarea.forEach((ta) => {
              ta.firstChild.dispatchEvent(new Event('keypress'))
            })
          })
        }
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async createUpdateMemoriaCalculo(data) {
      try {
        await this.$store.dispatch('saveUpdateMemoriaCalculo', {
          codCCustoPai: this.filters.codCCustoPai,
          codCCustoFilho: this.filters.codCCustoFilho,
          orcamentoId: this.filters.orcamentoId,
          memoriaCalculo: {
            codTBOrcamento: data.codTBOrcamento,
            mes: data.mes,
            texto: data.texto,
          },
        })
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    recalculateTotals(registro) {
      // Total da natureza orcamentária
      this.registros.naturezasOrcamentarias =
        this.registros.naturezasOrcamentarias.map((naturezaOrcamentaria) => {
          if (naturezaOrcamentaria.codTBOrcamento === registro.codTBOrcamento) {
            const { registros, ...resto } = naturezaOrcamentaria
            const totalAno = Object.values(this.meses).reduce(
              (accumulation, mes) => accumulation + Number(registros[mes]),
              0,
            )

            return {
              ...resto,
              registros: {
                ...registros,
                totalAno,
              },
            }
          }
          return { ...naturezaOrcamentaria }
        })

      // Total do mês
      const mesSelected = this.meses[registro.mes]

      this.registros.totais[mesSelected] =
        this.registros.naturezasOrcamentarias.reduce(
          (accumulation, naturezaOrcamentaria) =>
            accumulation + Number(naturezaOrcamentaria.registros[mesSelected]),
          0,
        )

      // Total geral
      this.registros.totais.totalAno = Object.values(this.meses)
        .map((mes) => Number(this.registros.totais[mes]))
        .reduce((accumulation, value) => accumulation + value, 0)
    },

    handlerPaste(event, registro) {
      const { codTBOrcamento, mes } = registro

      const valuePaste = event.clipboardData.getData('text/plain')
      const valor = valuePaste.replace(/\./g, '').replace(/,.*/, '')

      this.registros.naturezasOrcamentarias =
        this.registros.naturezasOrcamentarias.map((naturezaOrcamentaria) => {
          if (naturezaOrcamentaria.codTBOrcamento === codTBOrcamento) {
            const mesSelected = this.meses[mes]

            return {
              ...naturezaOrcamentaria,
              registros: {
                ...naturezaOrcamentaria.registros,
                [mesSelected]: valor,
              },
            }
          }
          return { ...naturezaOrcamentaria }
        })

      this.createUpdateRegistro({ codTBOrcamento, mes, valor })
    },

    resizeTextArea(event) {
      const element = event.target
      element.style.height = '18px'
      element.style.height = `${element.scrollHeight + 2}px`
    },
  },

  mounted() {
    this.createUpdateRegistro = debounce(this.createUpdateRegistro, 200)

    this.createUpdateMemoriaCalculo = debounce(
      this.createUpdateMemoriaCalculo,
      400,
    )
  },
}
</script>

<style scoped>
th.position-sticky.start-0.top-0 {
  min-width: 20rem;
  z-index: 2;
}

th {
  min-width: 12rem;
}

td.position-sticky,
th.position-sticky {
  z-index: 1;
}

td.position-sticky {
  background-color: #f1f1f7;
}

td {
  background-color: #f6f6f6;
  padding: 0.5rem 0.3rem;
}

.input-group-sm > .input-group-text,
.input-group-sm > .form-control {
  padding: 0.35rem;
  font-size: 0.7rem;
  line-height: 1;
}

.input-group-text,
input:disabled {
  background-color: #e9ecef;
}
</style>
